import React, { useState } from "react";
import LoadingScreen from "./LoadingScreen";

export default function ({ children }: { children: React.ReactNode }) {

    const [loading, setLoading] = useState(true)

    return <> {loading ? <LoadingScreen done={() => setLoading(false)} /> : children}</>
}